module.exports = __webpack_public_path__ + "img/dui_icon.00679867.png";